<div class="not-found-box">
  <div class="ctent-not-found">
    <p class="tit-not-found">404</p>
    <p class="txt-not-found">The page you were looking for doesn't exist!</p>
  </div>
</div>